import { createStore, get, set, del, keys, clear } from "idb-keyval";

// Per-user browser copy of Offline Analytics data (IndexedDB: payloads are a few MB).
const store = createStore("venue-vision-cache", "kv");
export const CACHE_TTL_MS = 24 * 60 * 60 * 1000;
const MAX_DATE_ENTRIES = 3;

const key = (userId, name) => `oa:${userId}:${name}`;

export const isFresh = (entry) => !!entry && Date.now() - entry.savedAt < CACHE_TTL_MS;

export async function readCache(userId, name) {
  try {
    return (await get(key(userId, name), store)) || null;
  } catch {
    return null;
  }
}

export async function writeCache(userId, name, value) {
  try {
    await set(key(userId, name), { savedAt: Date.now(), value }, store);
    if (name.startsWith("data:")) await pruneDates(userId);
  } catch (err) {
    console.warn("Could not save offline analytics cache:", err);
  }
}

async function pruneDates(userId) {
  const prefix = key(userId, "data:");
  const dataKeys = (await keys(store)).filter((k) => typeof k === "string" && k.startsWith(prefix));
  if (dataKeys.length <= MAX_DATE_ENTRIES) return;
  const entries = await Promise.all(dataKeys.map(async (k) => [k, (await get(k, store))?.savedAt || 0]));
  entries.sort((a, b) => a[1] - b[1]);
  await Promise.all(entries.slice(0, entries.length - MAX_DATE_ENTRIES).map(([k]) => del(k, store)));
}

export async function clearAllCache() {
  try {
    await clear(store);
  } catch {
    /* storage unavailable */
  }
}
